import Card from './card';
import { ComponentMultiStyleConfig } from '@chakra-ui/react';

export const StickyProgress: ComponentMultiStyleConfig = {
  parts: [
    'block',
    'stepRow',
    'iconIndicator',
    'activeIndicator',
    'blockFooter',
    'icon',
  ],
  baseStyle: {
    block: {
      ...Card.baseStyle,
      p: 0,
      h: 'auto',
      position: 'sticky',
      top: '12',
      maxW: '20rem',
      minW: { base: '17rem', lg: '20rem' },
    },
    stepRow: {
      paddingLeft: '5',
      py: '4',
      _notLast: {
        borderBottom: '1px solid',
        borderBottomColor: 'gray.border',
      },
      pos: 'relative',
    },
    activeIndicator: {
      position: 'absolute',
      top: '0',
      bottom: '0',
      left: '0',
      bgColor: 'primary',
      w: '3px',
    },
    iconIndicator: {
      position: 'absolute',
      right: '4',
      top: '50%',
      transform: 'translateY(-50%)',
    },
    blockFooter: {
      alignItems: 'strech',
      p: 4,
    },
    icon: {
      h: 6,
      w: 6,
    },
  },
  sizes: {},
  variants: {},
  defaultProps: {},
};
